<template>
  <edit-field ref="EDIT_QUANTITY"
              :value=value
              :contextId=contextId
              :editFieldInfo=editFieldInfo
              :min=min
              :max=max
              :required=required
              :disabled=readOnly
              :singleLine=true
              :bold="bold"
              :hideLabel="hideLabel"
              :dataTable="dataTable"
              @updated=setUpdated
              @context=setInitValue
              @error=setError>
  </edit-field>
</template>

<script lang="ts">
import EditBase from '@/framework/base/components/EditBase';
import EditField from '@/framework/base/components/EditField.vue';
import { EditFieldType, FieldInfo } from '@/framework/base/components/FieldInfo';
import validator, { rules, RULES_FRENCH_LABEL } from '@/generated/validators/ValidationRules';
import { FwkControls, RessourceFwkControl } from '@/ressources/globalRessources';
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    EditField
  },
  extends: EditBase,
  computed: {
    ressource() {
      return RessourceFwkControl(FwkControls.QUANTITE);
    },
    editFieldInfo(): FieldInfo {
      const type = EditFieldType.DECIMAL;
      const precision = 2;
      const format = null;
      const mask = null;
      const focus = null;
      const live = this.liveValidator;
      return new FieldInfo(this.ressource, type, precision, mask, format, focus, live);
    }
  },
  methods: {
    liveValidator(value: string): validator | null {
      return new validator(rules.currencyValid, RULES_FRENCH_LABEL.text.currencyValid.error);;
    },
    touch(): void {
      // @ts-expect-error : generated method
      this.$refs.CONTRAT_EDIT_BASE_SALARIE.touch();
    },
    setFocus(): void {
      // @ts-expect-error : generated method
      this.$refs.CONTRAT_EDIT_BASE_SALARIE.setFocus();
    }
  }
})

</script>
